import Base from '#BASE/store/userInfo/userInfo.store';
import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';
import constant from 'BASE/common/lotteryConstant';
export const dailyPayType = constant.DailyPayType;
export const ContractType = constant.ContractType;

export default class extends Base {
    constructor() {
        super();
        this.state.privileges.contractPermission = [];
        this.state.privileges.haveProportionalDividend = undefined;
        this.state.privileges.haveExternalGameProportionalDividend = undefined;
        this.state.privileges.sportContractCreationAllowed = undefined;
        this.state.privileges.externalGameContractCreationAllowed = undefined;
        this.state.privileges.signedAgentServiceFeeCreationAllowed = undefined;
        // 待遇管理頁面開關
        this.state.privileges.bonusManagementAllowed = undefined;
        // 我的待遇頁面開關
        this.state.privileges.haveMyDailyPayAndContract = undefined;
        this.actions[actionTypes.USER_INFO_PRIVILEGES_BONUS] = async (context, payload) => {
            context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                contractCreationAllowed: undefined,
                sportContractCreationAllowed: undefined,
                externalGameContractCreationAllowed: undefined,
                dailyPayCreationAllowed: undefined,
                haveContract: undefined,
                haveExternalGameContract: undefined,
                haveSportContract: undefined,
                haveDailyPay: undefined,
                dailyPayPermission: [],
                contractPermission: [],
                haveProportionalDividend: undefined,
                haveExternalGameProportionalDividend: undefined,
                haveBonusWallet: undefined,
                bonusManagementAllowed: undefined,
                haveMyDailyPayAndContract: undefined,
                signedAgentServiceFeeCreationAllowed: undefined,
                isDirectAgent: undefined
            });
            if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
                try {
                    let _result = await $.post('/api/BonusPrivileges/Get');
                    let dailyPayCreationAllowed =  (_result.dailyPayPermission.findIndex(permission => permission === dailyPayType.BET_PAY) >= 0 || _result.dailyPayPermission.findIndex(permission => permission === dailyPayType.EARN_PAY) >= 0) ? true : false;
                    let contractCreationAllowed = _result.contractPermission.findIndex(permission => permission === ContractType.LOTTERY) >= 0 ? true : false;
                    let sportContractCreationAllowed = _result.contractPermission.find(permission => permission === ContractType.SPORT) ? true : false;
                    let externalGameContractCreationAllowed = _result.contractPermission.find(permission => permission === ContractType.VIDEO_SLOT) ? true : false;
                    let signedAgentServiceFeeCreationAllowed = _result.haveSignedAgentServiceFeePermission;
                    let bonusManagementAllowed = (_result.dailyPayPermission.length > 0 || _result.contractPermission.length > 0 || _result.haveSignedAgentServiceFeePermission) ? true : false;
                    let haveMyDailyPayAndContract = (_result.haveDailyPay || 
                        _result.haveContract || _result.haveExternalGameContract || _result.haveSportContract) ? true : false;
                    context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                        contractCreationAllowed: contractCreationAllowed,
                        sportContractCreationAllowed: sportContractCreationAllowed,
                        externalGameContractCreationAllowed: externalGameContractCreationAllowed,
                        dailyPayCreationAllowed: dailyPayCreationAllowed,
                        haveContract: _result.haveContract,
                        haveExternalGameContract: _result.haveExternalGameContract,
                        haveSportContract: _result.haveSportContract,
                        haveDailyPay: _result.haveDailyPay,
                        dailyPayPermission: _result.dailyPayPermission,
                        contractPermission: _result.contractPermission,
                        haveProportionalDividend: _result.haveProportionalDividend,
                        haveExternalGameProportionalDividend: _result.haveExternalGameProportionalDividend,
                        haveBonusWallet: _result.haveBonusWallet,
                        bonusManagementAllowed: bonusManagementAllowed,
                        haveMyDailyPayAndContract: haveMyDailyPayAndContract,
                        signedAgentServiceFeeCreationAllowed: signedAgentServiceFeeCreationAllowed,
                        isDirectAgent: _result.isDirectAgent
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }
        };
        this.mutations[mutationTypes.USER_INFO_PRIVILEGES_BONUS] = (state, payload) => {
            state.privileges.contractCreationAllowed = payload.contractCreationAllowed;
            state.privileges.sportContractCreationAllowed = payload.sportContractCreationAllowed;
            state.privileges.externalGameContractCreationAllowed = payload.externalGameContractCreationAllowed;
            state.privileges.dailyPayCreationAllowed = payload.dailyPayCreationAllowed;
            state.privileges.haveContract = payload.haveContract;
            state.privileges.haveExternalGameContract = payload.haveExternalGameContract;
            state.privileges.haveSportContract = payload.haveSportContract;
            state.privileges.haveDailyPay = payload.haveDailyPay;
            state.privileges.dailyPayPermission = payload.dailyPayPermission;
            state.privileges.contractPermission = payload.contractPermission;
            state.privileges.haveProportionalDividend = payload.haveProportionalDividend;
            state.privileges.haveExternalGameProportionalDividend = payload.haveExternalGameProportionalDividend;
            state.privileges.haveBonusWallet = payload.haveBonusWallet;
            state.privileges.bonusManagementAllowed = payload.bonusManagementAllowed;
            state.privileges.haveMyDailyPayAndContract = payload.haveMyDailyPayAndContract;
            state.privileges.signedAgentServiceFeeCreationAllowed = payload.signedAgentServiceFeeCreationAllowed;
            state.privileges.isDirectAgent = payload.isDirectAgent;
        };
    }
}